export enum CHART_MODE {
  HOURS = 'HOURS',
  DAYS = 'DAYS',
}
